import { __extends } from "tslib";
import { CategoryBuilder, rootCategoryId } from '../../';
'use strict';
var ExtendedCategoryBuilder = /** @class */ (function (_super) {
    __extends(ExtendedCategoryBuilder, _super);
    function ExtendedCategoryBuilder() {
        var _this = _super.call(this) || this;
        var defaultCategory = {
            draftArticleCount: 0,
            publishedArticleCount: 0,
            id: '01d1d0e8-5245-49d4-8f1b-92bf07e05f86',
            locale: 'en',
            name: 'Category Title',
            parentId: rootCategoryId,
            url: 'http://fullurl.com',
            uri: '/cat-uri',
            position: 0,
            listed: true,
            visible: true,
            data: {
                iconKey: '',
                iconSrc: ''
            }
        };
        _this.category = defaultCategory;
        return _this;
    }
    ExtendedCategoryBuilder.prototype.withPublishedArticleCount = function (count) {
        this.category.publishedArticleCount = count;
        return this;
    };
    ExtendedCategoryBuilder.prototype.withDraftArticleCount = function (count) {
        this.category.draftArticleCount = count;
        return this;
    };
    ExtendedCategoryBuilder.prototype.build = function () {
        return this.category;
    };
    return ExtendedCategoryBuilder;
}(CategoryBuilder));
export { ExtendedCategoryBuilder };
//# sourceMappingURL=extended-category.builder.js.map